import i18next from 'i18next'

i18next

export enum OutletStatus {
    active = 'active',
    inactive = 'inactive'
}

export const getPortalOutletStatuses = () =>
    Object.keys(OutletStatus)
        .filter((key) => isNaN(Number(key)))
        .map((item) => ({
            label: item ? i18next.t(`enums:outletStatus.${item}`, {defaultValue: item}) : '',
            value: item
        }))
